import React from 'react';
import langConf from "../js/lang";
import BackButton from './BackButton';
import sheleg from '../api/sheleg';
import Signup from './Signup';
import Login from './Login';
import ForgotPassword from './ForgotPassword';

class Payment extends React.Component {

    state = { multiplePayments: false }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    validate = () => {
        let lang = this.props.lang;
        let errors = [];
        if (!this.validateId(document.querySelector('#cardholderId').value)) {
            errors.push(langConf[lang].errorId);
        }
        if (!this.validateCreditCard(document.querySelector('#creditCardNo').value)) {
            errors.push(langConf[lang].errorCardNo);
        }
        if (!this.validateExpiration(document.querySelector('#expirationYears').value, document.querySelector('#expirationMonths').value)) {
            errors.push(langConf[lang].errorExpiration);
        }
        if (!this.validateCvv(document.querySelector('#cvv').value)) {
            errors.push(langConf[lang].errorCvv);
        }
        if (errors.length === 0) {
            //TODO: payment
            return true;
        }
        else {
            this.errorMessages(errors);
            return false;
        }
    };

    handleMultiplePaymentsClick = (event) => {
        if (event.target.checked) {
            this.props.changeMultiplePayments(true);
        } else {
            this.props.changeMultiplePayments(false);
        }
    };

    handlePaymentClick = async (ccDetails) => {
        //console.log('ccDetails: ', ccDetails);
        //let ccPkg = {sesId: window.localStorage.getItem('sessionId'), WSCCfields: ccDetails, Err_dscrp: '', MerchantNote: '', clientNote: '', invType: 4, invNo: this.props.invNo };
        let ccFields = {
            cardNUM: ccDetails.cardNUM,
            cardExpiry: ccDetails.cardExpiry,
            transSum: ccDetails.transSum,
            CVV2: ccDetails.CVV2,
            id: ccDetails.id,
            transCurrency: ccDetails.transCurrency,
            creditType: ccDetails.creditType,
            firstPayment: ccDetails.firstPayment,
            fixedPayment: ccDetails.fixedPayment,
            numOfFixedPayments: this.props.multiPayments ? ccDetails.numOfFixedPayments - 1 : ccDetails.numOfFixedPayments,
            invType: 4,
            invNo: this.props.invNo
        };
        let response = '';
        if (this.validate()) {
            response = await sheleg.post(`ClearingPage/${this.props.slgCustId}/BillCC/${this.props.objType}/${this.props.objNo}`, ccFields)
            //console.log('response: ', response);
            if (response.data.toString() === '0') {
                this.props.changeTransactionResult('success');
                this.props.clearCart();
            }
            else {
                this.props.changeTransactionResult('failure');
            }
            if (this.props.transactionResult === 'success') {
                this.props.changeScreen('transactionResult');
            }
            else {
                window.alert(response.data);
            }
        }
    };

    NormalizeDate(day, month, year) {
        var finalDate = '';
        var finalMonth = '';
        var finalDay = '';
        if (month + 1 < 10) {
            finalMonth = '0' + (month + 1);
        }
        else {
            finalMonth = month + 1;
        }
        if (day < 10) {
            finalDay = '0' + day;
        }
        else {
            finalDay = day;
        }
        finalDate = '' + year + '-' + finalMonth + '-' + finalDay + '';
        return finalDate;
    }
    
    errorMessages(errors) {
        let errorMsg = '';
        for (let i = 0; i < errors.length; i++) {
            if (i !== errors.length - 1)
                errorMsg += `${errors[i]}, `;
            else
                errorMsg += errors[i];
        }
        window.alert(errorMsg);
    };

    validateId(idNumber) {
        var evenMultiplier = 1;
        var oddMultiplier = 2;
        var sum = 0;
        var thirdLine = [];
        var forthLine = [];
        if (idNumber.length <= 9 && idNumber.length > 7) {
            if (idNumber.length < 9) {
                while (idNumber.length < 9) {
                    idNumber = '0' + idNumber;
                }
            }
            for (let i = 0; i < idNumber.length; i++) {
                if (i % 2 === 0) {
                    thirdLine[i] = parseInt(idNumber[i]) * evenMultiplier;
                }
                else {
                    thirdLine[i] = parseInt(idNumber[i]) * oddMultiplier;
                }
            }
            for (let i = 0; i < thirdLine.length; i++) {
                if (thirdLine[i] > 9) {
                    forthLine[i] = parseInt(thirdLine[i]) / 10 + parseInt(thirdLine[i]) % 10;
                }
                else {
                    forthLine[i] = thirdLine[i];
                }
            }
            for (let i = 0; i < forthLine.length; i++) {
                sum += parseInt(forthLine[i]);
            }
            if (sum % 10 === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };

    paymentsChanged = (event) => {
        if (event.target.value < 2) {
            event.target.value = 2;
        }
        if (event.target.value > this.props.availablePayments) {
            event.target.value = this.props.availablePayments;
        }
        let itemSum = 0;
        this.props.finalOfferItems.map((item) => itemSum += this.props.currency === "ILS" ? (item.priceNis === null || item.priceNis === '' ? 0 : (item.priceNis * item.quantity)) : (item.priceUsd === null || item.priceUsd === '' ? 0 : (item.priceUsd * item.quantity)));
        if (!this.props.vatIncluded) {
            itemSum = itemSum * 1.17;
        }
        let payments = event.target.value;
        //console.log('payments: ', payments);
        this.calculatePayments(itemSum, payments);
    };

    firstPaymentChanged = (event) => {
        let itemSum = 0;
        this.props.finalOfferItems.map((item) => itemSum += this.props.currency === "ILS" ? (item.priceNis === null || item.priceNis === '' ? 0 : (item.priceNis * item.quantity)) : (item.priceUsd === null || item.priceUsd === '' ? 0 : (item.priceUsd * item.quantity)));
        if (!this.props.vatIncluded) {
            itemSum = itemSum * 1.17;
        }
        let payments = document.querySelector('#PaymentsCount').value;
        let firstPayment = event.target.value;
        //console.log('itemSum: ', itemSum, ' payments: ', payments, ' firstPayment: ', firstPayment)
        this.calculateAnotherPayment(itemSum, firstPayment, payments);
    };

    validateCreditCard(creditCardNumber) {
        var sum = 0;
        var thirdLine = [];
        var forthLine = [];
        var evenMultiplier = 1;
        var oddMultiplier = 2;
        if (creditCardNumber.length <= 19 && creditCardNumber.length > 10) {
            if (creditCardNumber.length % 2 === 0) {
                evenMultiplier = 2;
                oddMultiplier = 1;
            }
            for (let i = 0; i < creditCardNumber.length; i++) {
                if (i % 2 === 0) {
                    thirdLine[i] = parseInt(creditCardNumber[i]) * evenMultiplier;
                }
                else {
                    thirdLine[i] = parseInt(creditCardNumber[i]) * oddMultiplier;
                }
            }
            for (let i = 0; i < thirdLine.length; i++) {
                if (thirdLine[i] > 9) {
                    forthLine[i] = parseInt(thirdLine[i]) / 10 + parseInt(thirdLine[i]) % 10;
                }
                else {
                    forthLine[i] = thirdLine[i];
                }
            }
            for (let i = 0; i < forthLine.length; i++) {
                sum += parseInt(forthLine[i]);
            }
            if (sum % 10 === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (creditCardNumber.length <= 9 && creditCardNumber.length > 7) {
            if (creditCardNumber.length < 9) {
                while (creditCardNumber.length < 9) {
                    creditCardNumber = '0' + creditCardNumber;
                }
            }
            for (let i = 0, j = 9; i < creditCardNumber.length; i++, j--) {
                thirdLine[i] = parseInt(creditCardNumber[i]) * j;
            }
            for (let i = 0; i < thirdLine.length; i++) {
                sum += parseInt(thirdLine[i]);
            }
            if (sum % 11 === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    };

    validateExpiration(year, month) {
        var today = new Date();
        if (today.getFullYear().toString() === year) {
            if (today.getMonth() + 1 <= parseInt(month)) {
                return true;
            }
        }
        else if (today.getFullYear().toString() < year) {
            return true;
        }
        return false;
    };
    
    validateCvv(cvv) {
        if (cvv.length === 3)
            return true;
        else
            return false;
    };

    calculateAnotherPayment(sum, firstPayment, payments) {
        let sumLeft = parseFloat(parseFloat(sum) - parseFloat(firstPayment));
        let paymentsLeft = payments - 1;
        let anotherPayment = parseFloat(sumLeft / paymentsLeft).toFixed(2);
        document.querySelector('#AnotherPayment').value = anotherPayment;
    };


    calculatePayments(sum, payments) {
        let payment = parseFloat(parseFloat(sum) / parseFloat(payments)).toFixed(2);
        document.querySelector('#FirstPayment').value = payment;
        document.querySelector('#AnotherPayment').value = payment;
        document.querySelector('#FirstPayment').value = parseFloat(sum - (payment * (payments - 1))).toFixed(2);
    }

    openPayments = (open, sum) => {
        //console.log('multiple payments: ', open);
        this.setState({ multiplePayments: open });
    };

    // handleClick = async (event) => {
    //     event.preventDefault();
    //     let itemSum = 0;
    //     this.props.finalOfferItems.map((item) => itemSum += this.props.currency === "ILS" ? (item.priceNis === null ? 0 : (item.priceNis * item.quantity)) : (item.Usd === null ? 0 : (item.priceUsd * item.quantity)));
    //     await this.saveNewCart(this.props.finalOfferItems);
    //     if (itemSum === 0 || itemSum === null) {
    //         this.props.changeScreen('transactionResult');
    //     }
    //     else {
    //         this.props.changeScreen('payment');
    //     }
    // };

    // saveNewCart = async (finalOfferItems) => {
    //     let lang = this.props.lang;
    //     let newCartItems = [];
    //     let oldCartNo = 0;
    //     for (let i = 0; i < finalOfferItems.length; i++) {
    //         if (finalOfferItems[i].cartNo !== 0) {
    //             oldCartNo = finalOfferItems[i].cartNo;
    //         }
    //     }

    //     finalOfferItems.map((item) => newCartItems.push(
    //         {
    //             cartNo: item.cartNo === 0 ? oldCartNo : item.cartNo,
    //             cartItemDate: item.cartItemDate,
    //             itemNo: item.itemNo,
    //             itemDescription: lang === 'hebrew' ? item.hebName : item.engName,
    //             price: this.props.currency === 'ILS' ? item.priceNis : item.priceUsd,
    //             currency: this.props.currency === 'ILS' ? 9999 : 1,
    //             quantity: item.quantity,
    //             recKey: item.recKey,
    //             runningLineNo: item.runningLineNo
    //         }
    //     ));
    //     console.log('newCartItems: ', newCartItems);
    //     let response = await sheleg.post(`ClearingPage/${this.props.slgCustId}/PostInvoice/${this.props.objType}/${this.props.objno}`, newCartItems);
    //     //console.log('post invoice response: ', response);
    //     console.log('post invoice response.data: ', response.data);
    //     await this.props.changeInvNo(response.data);
    // };

    render() {
        let lang = this.props.lang;
        let currentTime = new Date();
        let currentYear = currentTime.getFullYear();
        let currentURL = this.props.currentURL;
        let itemCount = 0;
        let itemSum = 0;
        let currency = this.props.currency === 'ILS' ? langConf[lang].ILS : langConf[lang].USD;
        let payments = [];
        for (let i = 2; i<= this.props.availablePayments; i++){
            payments.push(i.toString());
        }
        //let dir = lang === 'hebrew' ? 'rtl' : 'ltr';

        let years = [currentYear, currentYear + 1, currentYear + 2, currentYear + 3, currentYear + 4, currentYear + 5, currentYear + 6];
        let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        this.props.finalOfferItems.map((item) => itemCount += item.quantity);
        this.props.finalOfferItems.map((item) => itemSum += this.props.currency === "ILS" ? (item.priceNis === null || item.priceNis === '' ? 0 : (item.priceNis * item.quantity)) : (item.priceUsd === null || item.priceUsd === '' ? 0 : (item.priceUsd * item.quantity)));
        let sumBeforeVat = itemSum;
        if (!this.props.vatIncluded) {
            itemSum = itemSum * 1.17;
        }
        const expirationYears = years.map((year) => { return <option key={year} value={year}>{year}</option>; });
        const expirationMonths = months.map((month) => { return <option key={month} value={month}>{month}</option> });
        const paymentsCount = payments.map((payment) => { return <option key={payment} value={payment}>{payment}</option> });
        const expiration = () => {
            if (lang === 'hebrew') {
                return (
                    <div className="col-4 col-xs-12 col-sm-12 col-md-5 col-lg-4">
                        <label className={`label expiration ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].cardExpiration}</label>
                        <select id="expirationYears" className="col-6 input-lg selectpicker form-control" >{expirationYears}</select>
                        <select id="expirationMonths" className="col-6 input-lg selectpicker form-control">{expirationMonths}</select>
                    </div>
                );
            } else {
                return (
                    <div className="col-4 col-xs-12 col-sm-12 col-md-5 col-lg-4">
                        <label><i className="calendar alternate icon" ></i><b>{langConf[lang].cardExpiration}</b></label>
                        <select id="expirationMonths" className="col-6 input-lg selectpicker form-control">{expirationMonths}</select>
                        <select id="expirationYears" className="col-6 input-lg selectpicker form-control" >{expirationYears}</select>
                    </div>
                );
            }
        }
        const multiPayments = () => {
            if (this.props.multiplePayments) {
                return (
                    <div>
                        <div className="col-12">
                            <div className='col-4'></div>
                            <div className="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                <label className={`label payment number-of-payments ${lang} col-12`}>{langConf[lang].numberOfPayments}</label>
                                <div className={`field payment number-of-payments ${lang}`}>
                                    {/* <input id='PaymentsCount' type='number' className={`form-control input-lg payment-field ${lang} col-12`} step="1.0" defaultValue={2} max={this.props.availablePayments} onChange={this.paymentsChanged} style={{ textAlign: 'right' }}></input> */}
                                    <select id="PaymentsCount" className="col-xl-6 col-6 input-lg selectpicker form-control" onChange={this.paymentsChanged}>{paymentsCount}</select>
                                </div>
                            </div>
                            <div className='col-4'></div>
                        </div>
                        <div className='col-2 col-xs-0 col-sm-0 col-md-2 col-lg-2'></div>
                        <div className="col-4 col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <div className={`ui big input field payment first-payment-sum ${lang}`}>
                                <label className={`label payment first-payment-sum ${lang} col-12`}>{langConf[lang].firstPaymentSum}</label>
                                <input id='FirstPayment' type='number' className={`form-control input-lg payment-field ${lang} col-12`} defaultValue={parseFloat(itemSum / 2).toFixed(2)} onChange={this.firstPaymentChanged} step={0.01} style={{ textAlign: 'right' }}></input>
                            </div>
                        </div>
                        <div className="col-4 col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <div className={`ui big input field payment another-payment-sum ${lang}`}>
                                <label className={`label payment another-payment-sum ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].anotherPaymentSum}</label>
                                <input id='AnotherPayment' type='number' className={`form-control input-lg payment-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} defaultValue={parseFloat(itemSum / 2).toFixed(2)} step={0.01} style={{ textAlign: 'right' }}></input>
                            </div>
                        </div>
                        <div className='col-2 col-xs-0 col-sm-0 col-md-2 col-lg-2'></div>
                    </div>
                );
            }
            else {
                return (
                    <div></div>
                );
            }
        };
        return (
            <div>
                <div className={`${lang === 'hebrew' ? 'hebrew' : 'english'} col-12`} style={{}}>
                    <div className="col-4 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                    <Login
                        //Globals
                        lang={lang}
                        currentURL={currentURL}
                        vendorData={this.props.vendorData}
                        slgCustId={this.props.slgCustId}
                        sessionId={this.props.sessionId}
                        objNo={this.props.objNo}
                        objType={this.props.objType}
                        //Variables
                        visible={this.props.paymentMode === 'login' ? true : false}
                        finalOfferItems={this.props.finalOfferItems}
                        existingUsername={this.props.existingUsername}
                        //Methods
                        changeLanguage={this.props.changeLanguage}
                        changeScreen={this.props.changeScreen}
                        changeObjectNo={this.props.changeObjectNo}
                        changeObjectType={this.props.changeObjectType}
                        changePaymentMode={this.props.changePaymentMode}
                        saveNewCart={this.props.saveNewCart}
                    />
                    <Signup
                        //Globals
                        lang={lang}
                        currentURL={this.props.currentURL}
                        sessionId={this.props.sessionId}
                        //Variables
                        cities={this.props.cities}
                        selectedCity={this.props.selectedCity}
                        selectedCityName={this.props.selectedCityName}
                        streets={this.props.streets}
                        selectedStreet={this.props.selectedStreet}
                        selectedStreetName={this.props.selectedStreetName}
                        visible={this.props.paymentMode === 'signup' ? true : false}
                        //Methods
                        changeSelectedCity={this.props.changeSelectedCity}
                        changeSelectedCityName={this.props.changeSelectedCityName}
                        changeSelectedStreet={this.props.changeSelectedStreet}
                        changeSelectedStreetName={this.props.changeSelectedStreetName}
                        getStreets={this.props.getStreets}
                        changeScreen={this.props.changeScreen}
                        changePaymentMode={this.props.changePaymentMode}
                        changeExistingUsername={this.props.changeExistingUsername}
                    />
                    <ForgotPassword
                        //Globals
                        lang={lang}
                        currentURL={this.props.currentURL}
                        vendorData={this.props.vendorData}
                        //Variables
                        visible={this.props.paymentMode === 'forgotPassword' ? true : false}
                        //Methods
                        changeLanguage={this.props.changeLanguage}
                        changeScreen={this.props.changeScreen}
                        changePaymentMode={this.props.changePaymentMode}
                    />

                    <div id="creditCardDetails" className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 panel panel-info" style={this.props.paymentMode !== 'payment' ? { display: 'none' } : { }} > 
                    {/* boxShadow: '0px 0px 5px 5px #888888' */}
                    <div className='panel-heading'>{langConf[lang].paymentDetails}</div>
                        <div className='col-12'>
                            <div className='col-2 col-lg-2 col-md-1 col-xs-0 col-sm-0'></div>
                            <div className="col-4 col-xs-12 col-sm-12 col-md-5 col-lg-4">
                                <div className={`field payment credit-card-number ${lang}`}>
                                    <label className={`label payment credit-card-number ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].cardNo}</label>
                                    <input id='creditCardNo' type='text' className={`form-control input-lg payment-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{ textAlign: 'right' }}></input>
                                </div>
                            </div>
                            <div className="col-4 col-xs-12 col-sm-12 col-md-5 col-lg-4">
                                <div className={`field payment credit-card-id ${lang}`}>
                                    <label className={`label payment credit-card-id ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].cardholderId}</label>
                                    <input id='cardholderId' type='text' className={`form-control input-lg payment-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{ textAlign: 'right' }}></input>
                                </div>
                            </div>
                            <div className='col-2 col-lg-2 col-md-1 col-xs-0 col-sm-0'></div>
                        </div>
                        <div className='col-12'>
                            <div className='col-2 col-lg-2 col-md-1 col-xs-0 col-sm-0'></div>
                            {expiration()}
                            <div className="col-4 col-xs-12 col-sm-12 col-md-5 col-lg-4">
                                <label className={`label payment credit-card-cvv ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].cvv}</label>
                                    <input id='cvv' type='text' className={`form-control input-lg payment-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{ textAlign: 'right' }}></input>
                            </div>
                            <div className='col-2 col-lg-2 col-md-1 col-xs-0 col-sm-0'></div>
                        </div>
                        <div className="col-12" >
                            <input type="checkbox" className='form-check-input' onChange={this.handleMultiplePaymentsClick} />
                            <label>{langConf[lang].multiPaymentsTransaction}</label>
                        </div>
                        <div>{multiPayments()}</div>
                        <div className="col-12 billing-sum panel panel-default" style={{}} >
                            <div className="col-12">
                                <h4>{`${langConf[lang].sumToPayNoVat} ${this.props.vatIncluded ? this.numberWithCommas(parseFloat(itemSum * 0.83).toFixed(2)) : this.numberWithCommas(parseFloat(sumBeforeVat).toFixed(2))} ${currency}`}</h4>
                            </div>
                            <div className="col-12">
                                <h4>{`${langConf[lang].totalVat} ${this.props.vatIncluded ? this.numberWithCommas(parseFloat(itemSum * 0.17).toFixed(2)) : this.numberWithCommas(parseFloat(itemSum - sumBeforeVat).toFixed(2))} ${currency}`}</h4>
                            </div>
                            <div className="col-12">
                                <h4>{`${langConf[lang].sumToPayVat} ${this.props.vatIncluded ? this.numberWithCommas(parseFloat(itemSum).toFixed(2)) : this.numberWithCommas(parseFloat(itemSum).toFixed(2))} ${currency}`}</h4>
                            </div>
                        </div>
                        <div className={`col-12 payment ${lang === 'hebrew' ? 'hebrew' : 'english'}`} >
                            <div className="col-6">
                                <BackButton
                                    //Globals
                                    lang={lang}
                                    currentURL={this.props.currentURL}
                                    //Methods
                                    onClick={(event) => { event.preventDefault(); this.props.changeScreen('finalOffer') }}
                                />
                            </div>
                            <div className="col-6">
                                <button className="btn btn-success btn-block btn-lg" onClick={
                                    (event) => {
                                        event.preventDefault();
                                        let ccDetails = {
                                            cardNUM: document.querySelector('#creditCardNo').value,
                                            cardExpiry: document.querySelector('#expirationMonths').value.toString() + document.querySelector('#expirationYears').value.substring(2, 4),
                                            transSum: parseFloat(itemSum).toFixed(2),
                                            CVV2: document.querySelector('#cvv').value,
                                            id: document.querySelector('#cardholderId').value,
                                            transCurrency: this.props.currency === 'ILS' ? 9999 : 1,
                                            creditType: !this.state.multiplePayments ? 1 : 8,
                                            firstPayment: document.querySelector('#FirstPayment') !== null ? parseFloat(document.querySelector('#FirstPayment').value).toFixed(2) : 0,
                                            fixedPayment: document.querySelector('#AnotherPayment') !== null ? parseFloat(document.querySelector('#AnotherPayment').value).toFixed(2) : 0,
                                            numOfFixedPayments: document.querySelector('#PaymentsCount') !== null ? parseInt(document.querySelector('#PaymentsCount').value) : 0
                                        };
                                        this.handlePaymentClick(ccDetails);
                                    }
                                } >
                                    <div className="visible content">{langConf[lang].purchase}</div>
                                    <div className="hidden content">{`${this.numberWithCommas(parseFloat(itemSum).toFixed(2))} ${currency}`}</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Payment;



// {/* <div className={`login-fields ${lang}`} style={{width: `${fieldsWidth}`}}>
//                         <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                             <input type="text" id="username" className={`login-field ${lang}`} placeholder={langConf[lang].username} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                         </div>
//                         <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                             <input type="password" id="password" className={`login-field ${lang}`} placeholder={langConf[lang].password} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                         </div>
//                         <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{display: 'block', paddingBottom: '5px', textAlign: 'center'}}><b>{langConf[lang].forgotPassword}</b></a>
//                         <a href={currentURL} className={`ui blue button login-button ${lang}`} onClick={this.handleLoginClick} style={{display: 'inline-block', marginRight: '25%'}}>{langConf[lang].login}</a>
//                     </div>
//                     <label className="credit-card" htmlFor="creditCardDetails" style={{marginRight: '25px'}}><b style={{fontSize: '2em'}}>{langConf[lang].elseRegister}</b></label>
//                     <br/>
//                     <div className={`ui input big signup-field ${lang}`} style={{padding: `${signupFieldPadding}`}}>
//                         <input type="text" id="fullName" className={`signup-field ${lang}`} placeholder={langConf[lang].fullName}/>
//                     </div>
//                     <br/>
//                     <div className={`ui right labeled input big signup-field ${lang}`} style={{padding: `${signupFieldPadding}`, paddingRight: '0px'}}>
//                     <div className="ui basic label">{langConf[lang].birthDate}</div>
//                         <input type="date" id="birthday" className={`signup-field ${lang}`} placeholder={langConf[lang].mobile}/>
//                     </div>
//                     <br/>
//                     <div className={`ui input big signup-field ${lang}`} style={{padding: `${signupFieldPadding}`}}>
//                         <input type="tel" id="mobile" className={`signup-field ${lang}`} placeholder={langConf[lang].mobile}/>
//                     </div>
//                     <br/>
//                     <div className={`ui input big signup-field ${lang}`} style={{padding: `${signupFieldPadding}`}}>
//                         <input type="text" id="idNo" className={`signup-field ${lang}`} placeholder={langConf[lang].idNo}/>
//                     </div>
//                     <br/>
//                     <div className="select-city" style={{marginRight: '3px'}}>
//                         <select id="city" className="ui large search dropdown" onChange={this.handleCitySelected}>
//                             <option value="">{langConf[lang].selectCity}</option>
//                             {cityList}
//                         </select>
//                     </div> <br/>
//                     <div className="select-street" style={{marginRight: '3px'}}>
//                         <select id="street" className="ui large search dropdown">
//                             <option value="">{langConf[lang].selectStreet}</option>
//                             {streetList}
//                         </select>
//                     </div> <br/>
//                     <div className={`ui input big signup-field ${lang}`} style={{padding: `${signupFieldPadding}`}}>
//                         <input type="text" id="address" className={`signup-field ${lang}`} placeholder={langConf[lang].houseNo}/>
//                     </div>

//                     <br/>
//                     <div className={`ui input big signup-field ${lang}`} style={{padding: `${signupFieldPadding}`, marginBottom: '20px'}}>
//                         <input type="email" id="email" className={`signup-field ${lang}`} placeholder={langConf[lang].email}/>
//                     </div>
//                     <br/> */}



// {/* <div className="ui big input number-of-payments" >
//                             <label className="ui mini input number-of-payments" ><b>{langConf[lang].numberOfPayments}</b></label>
//                             <input type="number" id="PaymentsCount" step="1.0" defaultValue={2} max={this.props.availablePayments} onChange={this.paymentsChanged}/>
//                         </div> */}
//                         {/* <div className="ui big input first-payment-sum">
//                             <label className="ui mini input first-payment-sum" ><b>{langConf[lang].firstPaymentSum}</b></label>
//                             <input type="number" id="FirstPayment" defaultValue={parseFloat(itemSum/2).toFixed(2)} onChange={this.firstPaymentChanged} step={0.01}/>
//                         </div> */}
//                         {/* <div className="ui big input another-payment-sum">
//                             <label className="ui mini input another-payment-sum" ><b>{langConf[lang].anotherPaymentSum}</b></label>
//                             <input type="number" id="AnotherPayment" defaultValue={parseFloat(itemSum/2).toFixed(2)} step={0.01}/>
//                         </div> */}